var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Viewport" }, [
    _c(
      "div",
      { staticClass: "Viewport_Inner" },
      [
        _vm.isShowImage
          ? _c("EditorCanvas", {
              attrs: {
                editScreen: _vm.editScreen,
                coordinates: _vm.coordinates,
                zoomedWidth: _vm.zoomedWidth,
                zoomedHeight: _vm.zoomedHeight,
                viewbox: _vm.viewbox
              },
              on: {
                loadImage: _vm.onLoadImage,
                errorImage: _vm.onErrorImage,
                addHighlight: _vm.onAddHighlight,
                selectHighlight: _vm.onSelectHighlight,
                setCoordinates: _vm.onSetCoordinates,
                removeHighlight: _vm.onRemoveHighlight
              }
            })
          : _c("EditorDrop", { on: { setImage: _vm.onSetImage } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }